// utils/cookieUtils.js
import { enqueueSnackbar } from 'notistack'
export const clearStudentCookies = () => {
    const hostname = window.location.hostname;
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
    
    // Define all possible student cookie names and paths
    const studentCookies = [
        // Primary student tokens
        { name: 'student_access_token', path: '/' },
        { name: 'student_refresh_token', path: '/' },
        { name: 'student_token', path: '/' },
        
        // Alternative naming patterns
        { name: 'student-token', path: '/' },
        { name: 'studentAuth', path: '/' },
        { name: 'student_session', path: '/' },
        { name: 'student-session', path: '/' },
        
        // API-specific cookies
        { name: 'student_access_token', path: '/api' },
        { name: 'student_refresh_token', path: '/api/students/refresh' },
    ];

    // Get current date in the past for expiration
    const pastDate = 'Thu, 01 Jan 1970 00:00:00 GMT';

    studentCookies.forEach(cookie => {
        // Method 1: Clear with domain
        if (!isLocalhost) {
            // For production domains
            const domains = [
                `.${hostname}`,            // .example.com
                `${hostname}`,             // example.com
                `.${hostname.split('.').slice(-2).join('.')}` // .co.in, .com.au etc
            ];
            
            // Remove duplicates
            const uniqueDomains = [...new Set(domains)];
            
            uniqueDomains.forEach(domain => {
                try {
                    document.cookie = `${cookie.name}=; path=${cookie.path}; domain=${domain}; expires=${pastDate}; Secure; SameSite=Strict`;
                } catch (e) {
                    console.warn(`Failed to clear cookie ${cookie.name} for domain ${domain}`);
                }
            });
        }
        
        // Method 2: Clear without domain (for localhost and as fallback)
        try {
            document.cookie = `${cookie.name}=; path=${cookie.path}; expires=${pastDate}`;
        } catch (e) {
            console.warn(`Failed to clear cookie ${cookie.name} without domain`);
        }
    });

    // Also try to clear using fetch API for HttpOnly cookies (if supported)
    // clearHttpOnlyCookies();
};

/**
 * Attempt to clear HttpOnly cookies via API call
 */
// const clearHttpOnlyCookies = async () => {
//     try {
//         // Make a request to clear cookies on server side
//         await fetch('/api/students/clear-cookies', {
//             method: 'POST',
//             credentials: 'include', // Important for cookies
//             headers: {
//                 'X-Requested-With': 'XMLHttpRequest'
//             }
//         });
//     } catch (error) {
//         // Silent fail - server-side clearing is optional
//     }
// };

/**
 * Clear all localStorage and sessionStorage
 */
export const clearLocalStorage = () => {
    try {
        // Clear student-specific items
        const studentKeys = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.toLowerCase().includes('student')) {
                studentKeys.push(key);
            }
        }
        
        studentKeys.forEach(key => {
            localStorage.removeItem(key);
        });
        
        // Clear common auth items
        const commonAuthKeys = [
            'token', 'access_token', 'refresh_token', 
            'auth_token', 'session', 'user', 'auth'
        ];
        
        commonAuthKeys.forEach(key => {
            localStorage.removeItem(key);
            sessionStorage.removeItem(key);
        });
        
        // Clear session storage completely
        sessionStorage.clear();
        
    } catch (error) {
        console.warn('Failed to clear storage:', error);
    }
};

/**
 * Cancel pending Axios requests
 */
export const cancelPendingRequests = () => {
    // If using axios interceptors with cancel tokens
    if (window.axios) {
        // Cancel all pending requests
        if (window.axiosCancelTokenSource) {
            window.axiosCancelTokenSource.cancel('User logged out');
        }
        
        // Clear authorization header
        delete window.axios.defaults.headers.common['Authorization'];
    }
    
    // If using fetch with AbortController
    if (window.fetchControllers) {
        window.fetchControllers.forEach(controller => controller.abort());
        window.fetchControllers = [];
    }
};

/**
 * Broadcast logout to other tabs
 */
export const broadcastLogout = () => {
    // Method 1: Using BroadcastChannel (modern browsers)
    if (typeof BroadcastChannel !== 'undefined') {
        try {
            const channel = new BroadcastChannel('student_auth');
            channel.postMessage({ type: 'LOGOUT', timestamp: Date.now() });
            setTimeout(() => channel.close(), 1000);
        } catch (error) {
            console.warn('BroadcastChannel not supported:', error);
        }
    }
    
    // Method 2: Using localStorage event (cross-browser)
    localStorage.setItem('student_logout_event', Date.now().toString());
    
    // Method 3: Using sessionStorage for immediate effect
    sessionStorage.setItem('logout', Date.now().toString());
};

/**
 * Force logout even when API fails
 */
export const forceLocalLogout = () => {
    clearStudentCookies();
    clearLocalStorage();
    broadcastLogout();
    window.location.href = '/students-login?error=logout_failed';
};

/**
 * Show logout success message
 */
export const showSuccessMessage = () => {

enqueueSnackbar('Logged out successfully', { variant: 'success' })

    // Using toast notification if available
    // if (window.toast) {
    //     window.toast.success('Logged out successfully');
    // } else if (window.alert) {
    //     window.alert('Logged out successfully');
    // }
};